import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import { colors } from 'Themes/Colors'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    inputRoot: {
      'label[data-shrink=false] + & ::-webkit-input-placeholder': {
        opacity: '0.5 !important',
      },
    },
    formControl: {
      width: '100%',
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    selectInput: {
      marginBottom: '0px',
    },
    selected: {
      backgroundColor: '#E8F0F6 !important',
    },
    errorMessage: {
      marginLeft: '23px',
    },
    input: {
      flexDirection: 'column',
    },
    header: {
      marginBottom: '8px',
      textAlign: 'left',
      fontWeight: 600,
    },
    subheader: {
      marginBottom: '8px',
      textAlign: 'left',
      fontWeight: 200,
      color: '#68737B',
    },
    helper: {
      display: 'flex',
      justifyContent: 'space-between',
      color: colors.darkGrey,
      padding: '5px',
    },
  })
)

export default useStyles
